module.exports = __webpack_public_path__ + "img/Min-kamp_Bilde-av-kona.480cc868.jpg";